
import Vue from 'vue'

import SwiperCounter from '~/mixins/swiper-counter'

export default Vue.extend({
  name: 'RecruitPeople',
  mixins: [SwiperCounter],
  props: {
    description: {
      type: String,
      default: 'DeNAで活躍するメンバーのストーリーを紹介します。'
    }
  },
  data() {
    const articleList = [
      {
        thumbnail:
          'https://images.ctfassets.net/7mrdlclm9xss/2yJJdEIpIdeKhbOFFI0Fpl/d76a20f7af74da24852124c696f506dc/DSC00015.jpg?w=3072&h=2048&fm=webp',
        href: 'https://fullswing.dena.com/archives/100182/',
        title:
          '「ユーザーにとっての価値を最速で磨き上げる。」DeNAの新しいAI開発を牽引する2つの職種と、新卒が担う挑戦',
        target: 'Specialist',
        tag: ['キャリア'] as string[]
      },
      {
        thumbnail: 'https://images.ctfassets.net/avfmoszunoew/7d9PaNCtI5IcyGDX3fZGqN/7ac88ae7a5151c7600b0f428d2874fd7/story_1_ogp.png',
        href: 'https://dena.ai/story/yokohama-dena-baystars-team/',
        title: '技術のアウトプット 現場と一緒に、 球団の未来を描いていく',
        target: 'Specialist',
        tag: ['キャリア'] as string[]
      },
      {
        thumbnail:
          'https://assets.cocoda.design/uploads/design_case/thumbnail/48227/1770678344-thumbnail.png',
        href: 'https://cocoda.design/fujirio75/p/p23b1d909e7ee',
        title:
          '「審美眼」と「ディレクション」の力を磨く。DeNA DESIGNにおけるAI時代の若手デザイナー育成施策について',
        target: 'Generalist',
        tag: ['キャリア'] as string[]
      },
      {
        thumbnail:
          'https://images.ctfassets.net/7mrdlclm9xss/OlIcATS88LtLD4vq962Ct/d2d0ef906479f26573c86b8c8019566a/%C3%A3_%C2%AA%C3%A3__%C3%A3__%C3%A3__%C3%A3__.png?w=2560&h=1706&fm=webp',
        href: 'https://fullswing.dena.com/archives/100166/',
        title: '【AIにオールインの現場】 社員のAI活用術を突撃取材！から3ヶ月。AI活用の進化を追う',
        target: 'Generalist',
        tag: ['キャリア'] as string[]
      }
    ]
    return {
      articleList
    }
  },
  computed: {
    totalSlides() {
      return this.articleList.length
    }
  }
})
